/* Info component for the Characters Create page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/PostCreateEditForm.module.css";

const ImportLocs = () => {
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
         <div className={`px-3 py-2 text-center ${styles.SubTitle6}`}>
          <p className={`${styles.Red} text-center`}>HOSPITALS INFO</p>
          <hr className={`mt-2 mb-0`}/>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Add Hospitals and their addresses for the Callsheet Neastest Hospital Dropdown.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> The Neastest Hospital name can also be added to a Location's Notes field and 
          if necessary the address can be found on this page.
          </p>
          <hr className={`mt-2 mb-0`}/>
        </div>
        </Col>
      </Row>
    </div>
  )
}

export default ImportLocs